<template>
  <div class="course-card" :style="{ backgroundColor: bgColor }">
    <div class="content">
      <div
        :class="
          type == 'domestic'
            ? 'title animate__animated animate__bounceInLeft'
            : 'title animate__animated animate__bounceInRight'
        "
        v-show="isShow"
      >
        <slot name="header"></slot>
      </div>
      <div
        :class="
          type == 'domestic'
            ? 'course-list animate__animated animate__bounceInRight'
            : 'course-list animate__animated animate__bounceInLeft'
        "
        v-show="isShow"
      >
        <nuxt-link
          :to="`/courseDetails/${type}/page/${item.id}`"
          v-for="(item, index) in list"
          :key="index"
          :class="index == 4 || index % 5 == 4 ? 'right nuxtLink' : 'nuxtLink'"
          target="_blank"
        >
          <img :src="item.imgsrc" alt="" srcset="" />
        </nuxt-link>
      </div>

      <div class="more">
        <button
          :style="{ backgroundColor: btnColor }"
          @click="openMoreCourses(true)"
        >
          <slot name="span"></slot>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  // emits: ["toPath"],
  props: {
    bgColor: {
      type: String,
      default: '#fff',
    },
    btnColor: {
      type: String,
      default: '#fff',
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: '',
    },
    list: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    clickToPath(id) {
      this.$emit('toPath', this.type, id)
    },
    openMoreCourses(status) {
      this.$emit('moreCourses', this.type, status)
    },
  },
}
</script>
<style lang="less" scoped>
.course-card {
  display: flex;
  justify-content: center;
  padding: 60px 0 60px 0;
  .content {
    width: 1280px;
    .title {
      display: flex;
      justify-content: center;
      margin-bottom: 60px;
    }
    .course-list {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      .nuxtLink {
        width: 230px;
        height: 250px;
        border-radius: 12px;
        margin-right: 32px;
        margin-bottom: 32px;
        overflow: hidden;
        cursor: pointer;
      }
      img {
        width: 100%;
      }
      .right {
        margin-right: 0 !important;
      }
    }
  }
  .more {
    display: flex;
    justify-content: center;
    padding-top: 30px;
    button {
      width: 432px;
      height: 84px;
      border-radius: 12px;
      left: 600px;
      line-height: 84px;
      color: rgba(50, 99, 255, 100);
      font-size: 24px;
      text-align: center;
      border: none;
      outline: none;
      cursor: pointer;
    }
  }
}
</style>
